import { createFileRoute } from "@tanstack/react-router";
import useAppStore from "@/store";
import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/")({
  component: HomePage,
});

function HomePage() {
  const navigate = useNavigate();
  const store = useAppStore();
  useEffect(() => {
    store.auth.fetchSession().then(async (session) => {
      if (session.user.role === "admin") {
        navigate({ to: "/dashboard" });
      } else if (session.user.role === "shop_owner") {
        if (
          session.user.business == null ||
          session.user.business == undefined
        ) {
          navigate({ to: "/setup/create-business" });
          return;
        }

        const shops = await store.user.getShops(session.user.id);
        if (shops.length == 0) {
          navigate({ to: "/setup/create-shop" });
        } else {
          navigate({ to: "/setup/select-shop" });
        }
      } else {
        navigate({ to: "/setup/select-shop" });
      }
    });
  }, []);
  return <></>;
}
